// Generated by scripts/generate-theme.mjs.
export const INTERACTION = {
  opacity: {
    '100': 1,
    '004': 0.04,
    '008': 0.08,
    '010': 0.1,
    '012': 0.12,
    '016': 0.16,
    '020': 0.2,
    '030': 0.3,
    '040': 0.4,
    '050': 0.5,
    '060': 0.6,
    '070': 0.7,
    '080': 0.8,
    '090': 0.9,
  },
  duration: {
    '100': 100,
    '150': 150,
    '200': 200,
    '300': 300,
    '400': 400,
    '600': 600,
    '800': 800,
    '050': 50,
    instant: 0,
  },
  labelLineHeight: 1.2,
} as const;
